import {
  REQUEST_INITIAL_SERVICE_LOADING,
  REQUEST_INITIAL_SERVICE_SUCCESS,
  REQUEST_INITIAL_SERVICE_ERROR,
} from "../constants/initialServiceConstant";

const initialState = {
  initialServiceIsLoading: false,
  initialServiceData: [],
  initialServiceError: [],
};

export const initialServiceReducer = (state = initialState, action) => {
  switch (action.type) {
    case REQUEST_INITIAL_SERVICE_LOADING:
      return {
        ...state,
        initialServiceIsLoading: true,
      };
    case REQUEST_INITIAL_SERVICE_SUCCESS:
      return {
        ...state,
        initialServiceIsLoading: false,
        initialServiceData: action.payload,
      };
    case REQUEST_INITIAL_SERVICE_ERROR:
      return {
        ...state,
        initialServiceIsLoading: false,
        initialServiceError: action.message,
      };
    default:
      return state;
  }
};
